import { Link } from "react-router-dom";

// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Prachitee",
  middleName: "",
  lastName: "Maratkar",
  message: " Passionate about using technology for social good ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/mprach18",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/prachiteemaratkar",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/Profile2.png"),
  imageSize: 375,
  message:
    "I'm a dedicated tech enthusiast with a passion for software engineering and data science. I hold a Bachelor's degree in Information Technology and a Master's degree in Computer Science. My professional experience spans software engineering, DevOps, and data engineering, with projects in machine learning and deep learning. I thrive on tackling challenging problems and leveraging my technical expertise to create innovative solutions that drive growth. With a solid foundation in computer science, I am eager to contribute to projects that harness the power of data and technology to make a positive impact. I'm currently looking for new challenges and opportunities in Software, Data and Machine Learning domains!",
  resume: "https://drive.google.com/file/d/14c6AxoJ_ILRUu6PrsyZucqoUOYSfUpcg/view?usp=sharing",
};

//\n\nPrior to joining CU, I was working as a software engineer for 1.5 years. During my tenure, I worked on developing data processing pipelines with Kafka and Logstash, and along with that I have a good amount of experience with DevOps technologies. Most of my projects are developed using Python language but I have also learned and worked with C, Java and R language.

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "mprach18", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["Automated-sign-language-recognition-for-emergency-situations","Legal-Named-Entities-Extraction-L-NER-using-Transformers","Big-Data-Architecture-Project"],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  // images: [
  //   { 
  //     img: require("../editable-stuff/hashirshoaeb.png"), 
  //     label: "First slide label", 
  //     paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
  //   },
  //   { 
  //     img: require("../editable-stuff/hashirshoaeb.png"), 
  //     label: "Second slide label", 
  //     paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
  //   },
  // ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "MySQL", value: 80 },
    { name: "Data Structures and algorithms", value: 80 },
    { name: "C", value: 65 },
    { name: "Java", value: 70 },
    { name: "Cloud technologies", value: 70 },
    { name: "DevOps", value: 85 },
    { name: "Neural Networks", value: 80 },

  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "Please feel free to email me",
  email: "mprachitee@gmail.com",
  url: "Schedule a meet - https://calendly.com/mprachitee/30min?month=2024-05",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: 'Software Engineer',// Here Add Company Name
      companylogo: require('../assets/img/dell.png'),
      date: 'June 2018 – Present',
    },
    {
      role: 'Front-End Developer',
      companylogo: require('../assets/img/boeing.png'),
      date: 'May 2017 – May 2018',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, leadership, getInTouch, experiences };
